import { SelectButton, SelectButtonChangeEvent } from "primereact/selectbutton";

interface IButtonProps {
  id?: string;
  testId?: string;
  label: string;
  value: any;
  items?: any[];
  onChange: (event: SelectButtonChangeEvent) => void;
}

const REISelectButton: React.FC<IButtonProps> = ({
  id,
  testId,
  label,
  value,
  items,
  onChange,
}) => {
  return (
    <SelectButton
      id={id}
      data-testid={testId ?? id}
      value={value}
      onChange={onChange}
      optionLabel={label}
      options={items}
    />
  );
};

export default REISelectButton;
